import React from 'react';

const MapIframe = ({ latitude, longitude }) => {
  const src = `https://web-treeosk.online/mapbox/mapbox.html?lat=${latitude}&lng=${longitude}`;
  return (
    <iframe
      src={src}
      style={{ width: '560px', height: '640px', border: 'none', marginLeft: '40px' }}
      title="Mapbox interactive map"
    />
  );
};

export default MapIframe;
